// extracted by mini-css-extract-plugin
module.exports = {"textObjectModuleContainer":"TextObjectModule_textObjectModuleContainer__1Y9eZ"};